"use client";

import { setShallowSearchParams, useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { normaliseHubSportParam } from "@/lib/conditions/hub/sports";
import type { HubSportKey } from "@/lib/conditions/hub/types";

/**
 * The hub's selected board sport, shared by the board island and the season awards card. The
 * single source of truth is the shareable `?sport=` param (shallow History API writes, so the ISR
 * HTML is never re-rendered): every island that calls `useHubSport` re-renders when any island
 * calls `selectHubSport`. Server HTML and the first client render see All (null).
 */
export const HUB_SPORT_PARAM = "sport";

/** The selected board sport (null = All), normalised for the sports the page shows. */
export function useHubSport(namedPublic: boolean): HubSportKey | null {
  return normaliseHubSportParam(useShallowSearchParam(HUB_SPORT_PARAM), namedPublic);
}

/** Select a board sport (null = All): writes `?sport=` without a navigation (the shared listeners re-render every island). */
export function selectHubSport(sport: HubSportKey | null, history: "push" | "replace" = "replace"): void {
  setShallowSearchParams({ [HUB_SPORT_PARAM]: sport }, { history });
}
